import COLORS from '../../../../../../../theme/colors';
import Button, { BUTTON_TYPE } from '../../../../../../generic/Button';
import Flex from '../../../../../../generic/Flex';
import { LargeEnvelope } from './icons';

type CheckEmailStepBodyProps = {
  domain: string;
  resendEmail: (() => void) | null;
};

export const CheckEmailStepBody = ({ domain, resendEmail }: CheckEmailStepBodyProps) => (
  <>
    <div className="text-center margin-bottom-xl">
      <LargeEnvelope fillColor={COLORS.fossaGreen} />
    </div>
    <p className="margin-bottom-lg">
      You’re almost done!
      {' '}
      Click the link in the email we just sent you to finish verifying that you own the domain <b>{domain}</b>
    </p>
    {resendEmail && (
      <div className="margin-bottom-xl">
        <Flex justify="space-between">
          <p className="nomargin italic">Don’t see an email from us?</p>
          <Button type={BUTTON_TYPE.SECONDARY} onClick={resendEmail}>Resend Email</Button>
        </Flex>
      </div>
    )}
  </>
);
